import { EActionTypes } from '../../actions/user';
import { IUser } from '../../types/redux/user';
import { TReduxActions } from '../../types/redux';

export const initialState: IUser = {
  isAuthenticated: false,
  anonymousUserId: null,
};

export function userReducer(state = initialState, action: TReduxActions): IUser {
  switch (action.type) {
    case EActionTypes.SET_USER_DATA:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
